<div class="model-content bg-secondary">
    <div class="madel-header ">
        <h3 mat-dialog-title class="model-title">DVR/NVR Details</h3>
    </div>
    <div>
        <button class="close" mat-button (click)="onNoClick()">X</button>
    </div>
</div>

<section>
    <div class="container">
        <div class="row">
            <div class="cctvcouncelling__sec col-md-12 col-sm-12">
                <div class="councellist__flex" *ngIf="data.data">
                    <div class="campus_address">
                        <img src="../../assets/image/dvr-image.svg" alt="dvr-image" class="dvr-image">
                        <h2 class="campus-name">{{data.data.campusName}}</h2>
                    </div>
                    <h4 class="building-list">{{data.data.buildingName || data.data.buildingName1}}</h4>
                    <h5 class="building-address">{{data.data.buildingAddress}}</h5>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="p-2">
    <form class="example-form">
        <form [formGroup]="myForm">
            <div>
                <div class="d-flex pt-3 gap-1">
                    <div class="col-md-6">
                        <span class="image_format">Building Name</span>
                    </div>
                    <div class="col-md-6">
                        <span class="image_format">IP Address</span>
                    </div>
                </div>
                <div class="d-flex pt-1 gap-1">
                    <div class="col-md-6">
                        <input class="form-control" type="text" 
                            formControlName="buildingname">
                        <span
                            *ngIf="(myForm.controls['buildingname'].touched||submitted)&&myForm.get('buildingname')?.hasError('required')"
                            class="tex-color">*Building Name is required</span>
                    </div>

                    <div class="col-md-6">
                        <input class="form-control" type="text"  formControlName="ipAddress">
                        <span
                            *ngIf="(myForm.controls['ipAddress'].touched||submitted)&&myForm.get('ipAddress')?.hasError('required')"
                            class="tex-color">*IP Address is required</span>
                    </div>
                </div>
                <div class="d-flex pt-3 gap-1">
                    <div class="col-md-6">
                        <span class="image_format">RTSP No</span>
                    </div>
                    <div class="col-md-6">
                        <span class="image_format">Server Port No</span>
                    </div>
                </div>
                <div class="d-flex pt-1 gap-1">
                    <div class="col-md-6">
                        <input class="form-control" type="text"  formControlName="rtspPortNo">
                        <span
                            *ngIf="(myForm.controls['rtspPortNo'].touched||submitted)&&myForm.get('rtspPortNo')?.hasError('required')"
                            class="tex-color">*Rtsp No is required</span>
                    </div>
                    <div class="col-md-6">
                        <input class="form-control" type="text"  formControlName="httpPortNo">
                        <span
                            *ngIf="(myForm.controls['httpPortNo'].touched||submitted)&&myForm.get('httpPortNo')?.hasError('required')"
                            class="tex-color">*Server Port No is required</span>
                    </div>
                </div>
                <div class="d-flex pt-3 gap-1">
                    <div class="col-md-6">
                        <span class="image_format">User Name</span>
                    </div>
                    <div class="col-md-6">
                        <span class="image_format">Password</span>
                    </div>
                </div>
                <div class="d-flex  pt-1 gap-1">
                    <div class="col-md-6">
                        <input class="form-control" type="text"  formControlName="userName">
                        <span
                            *ngIf="(myForm.controls['userName'].touched||submitted)&&myForm.get('userName')?.hasError('required')"
                            class="tex-color">*userName is required</span>
                    </div>

                    <div class="col-md-6">
                        <div class="pwd_eyeslash">
                            <input class="form-control" type="password"  formControlName="password"
                            [type]="showPassword ? 'text' : 'password'">
                        <span class="icon-pass"><i alt="show" class="far fa-eye eye-show" (click)="eyeslash()"
                                (click)="showPassword = !showPassword" [class.hide]="showPassword"></i>
                            <i alt="hide" class="far fa-eye-slash eye-hide" (click)="showPassword = !showPassword"
                                [class.hide]="!showPassword"></i></span>
                        <span
                            *ngIf="(myForm.controls['password'].touched||submitted)&&myForm.get('password')?.hasError('required')"
                            class="tex-color">*password is required</span>
                        </div>
                       
                    </div>


                </div>
                <div class="d-flex pt-3 gap-1">
                    <div class="col-md-6">
                        <span class="image_format">Model No & Serial No</span>
                    </div>
                    <!-- <div class="col-md-6">
                        <span class="image_format">Serial Number</span>
                    </div> -->
                </div>
                <div class="d-flex  pt-1 gap-1">
                    <div class="col-md-12">
                        <input class="form-control" type="text"  formControlName="dvrModelNumber">
                        <span
                            *ngIf="(myForm.controls['dvrModelNumber'].touched||submitted)&&myForm.get('dvrModelNumber')?.hasError('required')"
                            class="tex-color">*Model No & Serial No is required</span>
                    </div>
                    <!-- <div class="col-md-6">
                        <input class="form-control" type="text"  formControlName="serialNumber">
                        <span
                            *ngIf="(myForm.controls['serialNumber'].touched||submitted)&&myForm.get('serialNumber')?.hasError('required')"
                            class="tex-color">*serialNumber is required</span>
                    </div> -->
                </div>
                <div class="d-flex pt-3 gap-1">
                    <div class="col-md-6">
                        <span class="image_format">Max channel</span>
                    </div>
                    <div class="col-md-6">
                        <span class="image_format">Total Installed</span>
                    </div>
                </div>
                <div class="d-flex pt-1 gap-1">
                    <div class="col-md-6">
                        <input class="form-control" type="text" OnlyNumber
                            formControlName="maxNoOfChannels" maxlength="4">
                        <span
                            *ngIf="(myForm.controls['maxNoOfChannels'].touched||submitted)&&myForm.get('maxNoOfChannels')?.hasError('required')"
                            class="tex-color">*maxchannel is required</span>
                            <!-- <div *ngIf="myForm.get('maxNoOfChannels')?.errors?.['pattern']">Only numeric values are allowed.</div> -->
                    </div>
                    <div class="col-md-6">
                        <input class="form-control" type="text" OnlyNumber
                            formControlName="totalCamerasInstalled" (keyup)="onTotalworking($event)">
                        <span
                            *ngIf="(myForm.controls['totalCamerasInstalled'].touched||submitted)&&myForm.get('totalCamerasInstalled')?.hasError('required')"
                            class="tex-color">*totalInstalled is required</span>
                            <span *ngIf="showErrorForworkingDVR" class="work_status">Total Working cannot be greater than Total Install</span>
                    </div>
                </div>
                <div class="d-flex pt-3 gap-1">
                    <div class="col-md-6">
                        <span class="image_format">Total Working</span>
                    </div>
                    <div class="col-md-6">
                        <span class="image_format">Authentication</span>
                    </div>
                </div>
                <div class="d-flex pt-1 gap-1">
                    <div class="col-md-6">
                        <input class="form-control" type="text" OnlyNumber
                            formControlName="totalWorkingCameras"  (keyup)="onTotalworking($event)">
                        <span
                            *ngIf="(myForm.controls['totalWorkingCameras'].touched||submitted)&&myForm.get('totalWorkingCameras')?.hasError('required')"
                            class="tex-color">*totalWorking is required</span>
                    </div>
                    <div class="col-md-6">
                        <input class="form-control" type="text" id="formFile" 
                            formControlName="rtspAuthentication">
                        <span
                            *ngIf="(myForm.controls['rtspAuthentication'].touched||submitted)&&myForm.get('rtspAuthentication')?.hasError('required')"
                            class="tex-color">*Authentication is required</span>
                    </div>
                </div>
                <div class="d-flex pt-3 gap-1">
                    <div class="col-md-6">
                        <span class="image_format">Image Format</span>
                    </div>
                    <div class="col-md-6">
                        <span class="image_format">DVR Status</span>
                    </div>
                </div>
                <div class="d-flex pt-1 gap-1">
                    <div class="col-md-6">
                        <mat-radio-group aria-label="Select an option" formControlName="imageFormat">
                            <mat-radio-button value="1">JPEG</mat-radio-button>
                            <mat-radio-button value="2">NA</mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div class="col-md-6">
                        <mat-radio-group aria-label="Select an option" formControlName="dvrStatus">
                            <mat-radio-button value="1">OPENED</mat-radio-button>
                            <mat-radio-button value="2">CLOSED</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
        </form>
        <div class="text-center pt-3">
            <button mat-flat-button color="primary" [disabled]="showErrorForworkingDVR" (click)="submit()">Submit</button>
        </div>
    </form>
</div>
